import { createAction } from "redux-actions";
import { ADD_BENEFICIARY, GET_BENEFICIARIES, GET_BENEFICIARIES_CORE, DELETE_BENEFICIARY, UPDATE_BENEFICIARY } from "../constants";
import { feathersFindDataAll,feathersCreateData, feathersDeleteData, feathersPatchData } from "../services";

export const addBeneficiary = createAction(ADD_BENEFICIARY, (data) => feathersCreateData('users-default', data )())
export const deleteBeneficiary = createAction(DELETE_BENEFICIARY, (data) => feathersDeleteData('users-default', data )())
export const updateBeneficiary = createAction(UPDATE_BENEFICIARY, (id, data) => feathersPatchData('users-default', id, data )())
/* export const addBeneficiary = createAction(ADD_BENEFICIARY, (cedule) => feathersCreateData('core-server',{
    service: 'CLIENT',
    func: 'GET_USER',
    cedule
})()) */
export const getBeneficiaries = createAction(GET_BENEFICIARIES, (owner) => feathersFindDataAll('users-default',{owner, state : true, $limit: 200, $sort: {
    name: 1
}})())
export const getBeneficiaryCore = createAction(GET_BENEFICIARIES_CORE, (data) => feathersCreateData('core-server',{
    service: 'ACCOUNT',
    func: 'RETURN DATA ACCOUNTS BY IDENTIFICATION CLIENT ADD BENEFICIARY',
    data
})())

export const getBeneficiaryCoreAccount= createAction(GET_BENEFICIARIES_CORE, (number) => feathersCreateData('core-server',{
    service: 'ACCOUNT',
    func: 'RETURN DATA ACCOUNTS BY NUMBER ACCOUNT',
    data : {
        NumeroCuenta: number
    }
})())